export function replaceTransformers(
  copy: string,
  transformers: {
    [T in string]?: (copy: string) => any
  },
): string | any[] {
  if (!/(\[%\w+\(.+?\)])/.test(copy)) {
    return copy
  }

  return copy.split(/(\[%\w+\(.+?\)])/).map((s) => {
    const groups = /\[%(?<key>\w+)\((?<matchedCopy>.+?)\)]/.exec(s)?.groups
    if (!groups) {
      return s
    }
    const { matchedCopy, key } = groups
    if (!matchedCopy) {
      return s
    }
    return transformers[key as string]?.(matchedCopy) ?? matchedCopy
  })
}
